import React from 'react';
import './styles.scss';

const Input = ({ value, name, onChange, onBlur, error, label }) => (
  <div className="checkout-register-mini-form__input">
    <label>{label}</label>
    <input
      type="text"
      placeholder={label}
      name={name}
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
    />
    <div className="error">{error}</div>
  </div>
);

export default Input;
